export const updateIsPartner = value => ({
  type: 'UPDATE_IS_PARTNER',
  payload: value,
});

